import { Outlet, Link } from "react-router-dom";
import Container from 'react-bootstrap/Container';

const Layout = () => {
    return (
        <>
            <nav className="navbar bg-light navbar-light">
                <div className="container">
                    <a className="navbar-brand" href="/">Its ok, eat that donut</a>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="collapsibleNavbar">
                        <ul className="navbar-nav">
                            <li className="nav-item">
                                <Link to="/" className="nav-link">Home</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/exercise" className="nav-link">Do todays workout</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/exercise" className="nav-link">Do another workout</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/workout" className="nav-link">Create a plan</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/workout" className="nav-link">View exercise plan</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/myworkouthistory" className="nav-link">My Workout History</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/exerciselist" className="nav-link">View all exercises</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/mypersonaldetails" className="nav-link">Edit My Personal Details</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/logout" className="nav-link">Logout</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>

            <Container fluid className="my-3">
                <Outlet />
            </Container>
        </>
    )
};

export default Layout;